import { ExtractionDisplayStatus, ExtractionSummary } from '../../types';
import { IAsynchronouslyLoadedValue } from './asynchronouslyLoadedValue';

export enum ExtractionSortDirection {
    ascending = 'ascending',
    descending = 'descending',
}

export enum SearchableExtractionFields {
    customerReference = 'customerReference',
    fileName = 'fileName',
    requestedBy = 'requestedBy',
}

export interface ExtractionListState {
    currentPage: number;
    sortColumn: string;
    sortDirection: ExtractionSortDirection;
    startAt: number;
    totalRecords: number;
    statusFilter: ExtractionDisplayStatus[];
    dateRange: string[];
    query: string;
    searchBy: SearchableExtractionFields;
    extractionData: IAsynchronouslyLoadedValue<ExtractionSummary[]>;
}
